import React from 'react';
import Tabs from 'react-bootstrap/Tabs';
import './CustomTab.css';

// interface tabsListType {
//     title: string,
//     eventKey: string,
//     content: string,
//   }

type CustomTabType = {
  defaultActiveKey: string;
  id: string;
  justify?: boolean;
  activeKey: string;
  handleSelectTab: (eventKey: any) => void;
  children?: React.ReactNode;
  className: string;
};

const CustomTab: React.FC<CustomTabType> = ({
  defaultActiveKey,
  id,
  justify,
  activeKey,
  handleSelectTab,
  children,
  className,
}) => {
  return (
    <Tabs
      className={className}
      defaultActiveKey={defaultActiveKey}
      id={id}
      justify={justify}
      activeKey={activeKey}
      onSelect={handleSelectTab}
    >
      {children}
    </Tabs>
  );
};

export default CustomTab;
